import { FieldWidthEnum } from '../../../cer/cer-data/cer-data-types';
import { CerFormAdapter } from '@cer/cer-form/cer-form-adapter';
import { CerFormView } from '@cer/cer-form/cer-form-view';

export class BankAccountTransferSetupForm extends CerFormAdapter {

  override view(): CerFormView {
    return new CerFormView({
      viewMetadata: {
        name: 'bank-ovf-indstillinger', dataApiName: 'BankAccountTransferSetup', text: 'Bankoverførsel indstillnger',
        primaryKey: 'id', baseFields: ['id','history']
      },
      fieldMetadata:
        [
          { name: 'originator', text: "Kundenr" },
          { name: 'originatorSchema', text: "Kundenr.type" },
          { name: 'format', text: "Format",}
        ]
    });
  }
}
